/**
 * Orders Page
 */
import React from 'react';
import Layout from '@/components/Layout';
import Orders from '../../../containers/Orders';
import { useSetSSRStore, useSSRSelector } from '../../../redux';
import { checkForWrongDomain } from '../../../utils/checkForWrongDomain';
import { getSSRStoreData } from '../../../utils/ssrPageData';
import { getRequiredCtxProps } from '../../../utils/getRequiredCtxProps';

const OrdersPage = (props) => {
  useSetSSRStore(props.ssrStore);
  const storeData = useSSRSelector((state) => state.storeReducer.store);

  return (
    <Layout
      store={storeData}
      title={`Orders - Now Shop Online`}
      Icon={storeData?.store_info?.logo_image}
      metaDescription={
        'Now order online from my whatsapp store & pay using 150+ UPI Apps'
      }
      OGImage={storeData?.store_info?.logo_image}
    >
      <Orders />
    </Layout>
  );
};

/**
 * @param {import('next').NextPageContext} ctx
 * @returns {any}
 */
export async function getServerSideProps(ctx) {
  if (checkForWrongDomain(ctx)) return {};

  const ssrPropData = await getSSRStoreData(ctx, {
    additionalDataToFetch: ['theme', 'collections', 'categories', 'themeHtml', 'seo'],
  });

  const extraProps = getRequiredCtxProps(ctx, ssrPropData);

  return { props: { ...ssrPropData, ...extraProps } };
}

export default OrdersPage;
